module.exports = __webpack_public_path__ + "static/media/basketball-signup.3c592c1e.webp";